'use client';

import { useMyPlannerWorkScheduleCalendarData } from '@/entities/planner/model/useMyPlannerWorkScheduleCalendarData';
import type { PlannerWorkScheduleData } from '@/widgets/planner/planner-work-schedule-tab/model/plannerWorkScheduleData.types';

/**
 * 플래너 전용: 내 근무표 데이터
 * /api/v1/planners/me API 사용
 */
export function usePlannerWorkScheduleDataByMe(month: string): PlannerWorkScheduleData {
  const { scheduleData, isLoading, error } = useMyPlannerWorkScheduleCalendarData({
    month,
    enabled: !!month,
  });

  return {
    scheduleData,
    isLoading,
    error,
  };
}
